// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_k0_","buttons":"styles_buttons__27ktt"};